/**
 * Number-format helpers shared by the builder shell and its step components:
 * they translate the Format accordion's `numberFormat` pick into the two
 * keys the widget components read (`numberFormat` + `numberScale`).
 */

/** Widget `numberFormat` ('plain' | 'thousands' | 'percent') for a tile format. */
export function toKpiNumberFormat(format?: Record<string, unknown>): string {
  const selected = String(format?.['numberFormat'] ?? 'NONE');
  if (selected === 'THOUSANDS') return 'thousands';
  if (selected === 'PERCENT') return 'percent';
  return 'plain';
}

/** Widget `numberScale` for a `numberFormat` pick (COMPACT / SCALE_THOUSANDS / MILLIONS / BILLIONS). */
export function toNumberScale(value: unknown): string {
  switch (String(value ?? 'NONE')) {
    case 'COMPACT': return 'compact';
    case 'SCALE_THOUSANDS': return 'thousands';
    case 'MILLIONS': return 'millions';
    case 'BILLIONS': return 'billions';
    default: return 'none';
  }
}
